import { languageMap } from ".."

languageMap.npmignore =
	languageMap.hgignore =
	languageMap.gitignore =
	languageMap.ignore =
		{
			comments: {
				line: "#",
			},
		}
